import type { ButtonVariant } from '@/lib/sanity/dto';
import { BUTTON_VARIANT_MAP } from '@/lib/ui/tailwind-mapping.constants';
import { stegaClean } from '@/lib/utils/stega';
import type { UiButtonVariant } from './UiButton.types';

function isButtonVariant(value: string): value is ButtonVariant {
    return value in BUTTON_VARIANT_MAP;
}

/** The editor's weight when it is a known one, else the use site's. The value is
 *  a lookup key, so it never keeps its draft-mode stega encoding. */
export function resolveButtonVariant<T extends UiButtonVariant>(
    value: string | undefined,
    fallback: T,
): ButtonVariant | T {
    const clean = value ? stegaClean(value).trim() : '';

    return isButtonVariant(clean) ? clean : fallback;
}
